import { Currency } from '@/core/currency/interfaces';

const BND: Currency = {
    name: 'Brunei Dollar',
    demonym: 'Brunei',
    majorSingle: 'Dollar',
    majorPlural: 'Dollars',
    codeNumeric: '096',
    symbol: 'B$',
    symbolNative: '$',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BND',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default BND;
